import { S3Client } from '@aws-sdk/client-s3';

const getS3Client = () => {
  // Get aws-credentials from localStorage
  const awsCredentials = localStorage.getItem('aws_credentials');
  if (!awsCredentials) {
    clearLocalStorage();
    sessionStorage.clear();
    window.location.href = '/sign-in';
    return null;
  }

  // Parse aws-credentials
  // No need to check expiry because handled in refresh token
  const credentials = JSON.parse(awsCredentials);

  // Create S3 client
  const s3Client = new S3Client({
    region: credentials.region,
    credentials: {
      accessKeyId: credentials.access_key_id,
      secretAccessKey: credentials.secret_access_key,
      sessionToken: credentials.session_token,
    },
    requestChecksumCalculation: 'WHEN_REQUIRED',
  });
  return s3Client;
};

export default getS3Client;
